export const DEBUG_VIDEO_PLAYER_LS_KEY = 'debugVideoPlayer';

export const isDebugVideoPlayerEnabled = () =>
  typeof window !== 'undefined' &&
  window.localStorage.getItem(DEBUG_VIDEO_PLAYER_LS_KEY) === 'true';

export const clearLocalStoragePreservingDebugVideoPlayer = () => {
  const debugVideoPlayer = isDebugVideoPlayerEnabled();
  localStorage.clear();

  if (debugVideoPlayer) {
    localStorage.setItem(DEBUG_VIDEO_PLAYER_LS_KEY, 'true');
  }
};
